import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { settingsSchema } from '~/utils/schemas';
import { reset } from './sharedActions';

type SettingsState = z.infer<typeof settingsStateSchema>;
export const settingsStateSchema = z.nullable(settingsSchema);
export const settingsSlice = createSlice({
  name: 'settings',
  initialState: null as SettingsState,
  reducers: {
    setSettings: (_, action: PayloadAction<SettingsState>) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(reset, (_, action) => action.payload?.settings ?? null);
  },
});
